export enum UserRole {
    USER,
    FRANCHISEE,
    FRANCHISE_OWNER,
    ADMIN,
    SUPER,
}
